import {gql} from '@apollo/client'

export const GET_ALL_COMMISSION_REPORTS_DETAILS_API = gql`
  query allCommissionReportsDetails(
    $offset: Int
    $before: String
    $after: String
    $first: Int
    $last: Int
    $status: String
    $commissionReport: String
    $policy: String
    $user: [String]
    $commissionType: String
    $effectiveMonth: Int
    $effectiveYear: Int
    $client: String
    $memberId: String
    $activeClaim: Boolean
    $carrierId: String
    $assignedTo: [String]
  ) {
    allCommissionReportsDetails(
      offset: $offset
      before: $before
      after: $after
      first: $first
      last: $last
      status: $status
      commissionReport: $commissionReport
      policy: $policy
      user: $user
      commissionType: $commissionType
      effectiveMonth: $effectiveMonth
      effectiveYear: $effectiveYear
      client: $client
      memberId: $memberId
      activeClaim: $activeClaim
      carrierId: $carrierId
      assignedTo: $assignedTo
    ) {
      totalCount
      totalPending
      totalApproved
      totalNotAssigned
      grandTotal
      totalApprovedWithPolicy
      totalApprovedWithoutPolicy
      pageInfo {
        hasNextPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          commissionType
          status
          rate
          members
          subtotal
          effectiveMonth
          effectiveYear
          memberId
          client
          activeClaim
          commissionReport {
            id
            name
            carrier {
              id
            }
          }
          policy {
            id
            policyName
          }
          user {
            id
            firstName
            lastName
            email
            npn
          }
          assignedTo {
            id
            firstName
            lastName
            email
            npn
          }
          stateEU {
            id
            name
            code
          }
        }
      }
    }
  }
`


export const GET_COMMISSION_REPORTS_DETAIL_BY_ID_API = gql`
  query commissionReportsDetailById($id: String) {
    commissionReportsDetailById(id: $id) {
      id
      commissionType
      status
      rate
      members
      subtotal
      effectiveMonth
      effectiveYear
      memberId
      client
      activeClaim
      commissionReport {
        id
        name
        effectiveMonth
        effectiveYear
        status
        carrier {
          id
          name
        }
        totalApproved
        totalPending
        totalNotAssigned
      }
      policy {
        id
        policyNumber
      }
      user {
        id
        firstName
        lastName
        email
      }
      stateEU {
        id
        name
        code
      }
    }
  }
`


export const GET_COMMISSION_REPORT_PAYROLL_BY_AGENT_AND_ADVISOR = gql`
  query commissionReportPayrollByAgentAndAdvisor(
    $status: String
    $commissionReport: String
    $commissionType: String
    $client: String
  ) {
    commissionReportPayrollByAgentAndAdvisor(
      status: $status
      commissionReport: $commissionReport
      commissionType: $commissionType
      client: $client
    ) {
      totalAmount
      agent {
        id
        firstName
        lastName
        email
        npn
        cellphone
      }
      advisors {
        amount
        advisor {
          id
          firstName
          lastName
          email
        }
      }
    }
  }
`

export const GET_COMMISSION_REPORT_PAYROLL_BY_ADVISOR = gql`
  query commissionReportPayrollByAdvisor(
    $status: String
    $commissionReport: String
    $commissionType: String
    $client: String
  ) {
    commissionReportPayrollByAdvisor(
      status: $status
      commissionReport: $commissionReport
      commissionType: $commissionType
      client: $client
    ) {
      totalAmount
      user {
        id
        firstName
        lastName
        email
        cellphone
        npn
      }
    }
  }
`

export const GET_COMMISSION_REPORT_PAYROLL = gql`
  query commissionReportPayroll(
    $status: String
    $commissionReport: String
    $user: String
    $commissionType: String
    $client: String
    $memberId: String
  ) {
    commissionReportPayroll(
      status: $status
      commissionReport: $commissionReport
      user: $user
      commissionType: $commissionType
      client: $client
      memberId: $memberId
    ) {
      totalAmount
      user {
        id
        firstName
        lastName
        email
        cellphone
        npn
      }
    }
  }
`

export const GET_NOTES_COMMISSION_DETAIL = gql`
  query NotesByCommissionReportDetail($commissionReportDetailId: String!) {
    commissionReportNotesByDetail(commissionReportDetailId: $commissionReportDetailId) {
      id
      comments
      noteType
      claimReason
      created
      user {
        id
        firstName
        lastName
      }
    }
  }
`

export const GET_COMMISSION_REPORT_DETAILS_BY_TERM = gql`
  query commissionReportDetailsByTerm($term: String) {
    commissionReportDetailsByTerm(term: $term) {
      id
      status
      rate
      members
      subtotal
      effectiveMonth
      effectiveYear
      memberId
      client
      commissionReport {
        id
        name
        effectiveMonth
        effectiveYear
        carrier {
          id
          name
        }
      }
      user {
        id
        firstName
        lastName
        email
        npn
      }
    }
  }
`

export const GET_POLICY_COMMISSION_REPORTS_DETAILS = gql`
  query policyCommissionReportsDetails($policyId: ID!) {
    commissionReportsDetailsFiltered(policyId: $policyId) {
      id
      commissionType
      status
      members
      effectiveMonth
      effectiveYear
      client
      memberId
      commissionReport {
        id
        name
        status
        effectiveMonth
        effectiveYear
        carrier {
          id
        }
      }
      policy {
        id
        policyName
      }
    }
  }
`

export const GET_MEMBER_COMMISSION_REPORTS_DETAILS = gql`
  query memberCommissionReportsDetails($memberId: String!) {
    allCommissionReportsDetails(first: 500, memberId: $memberId) {
      edges {
        node {
          id
          commissionType
          status
          members
          effectiveMonth
          effectiveYear
          client
          memberId
          commissionReport {
            id
            name
            effectiveMonth
            effectiveYear
            status
            carrier {
              id
              name
            }
          }
          policy {
            id
            policyName
          }
        }
      }
    }
  }
`
